import Http from "@/utils/request.js"

// 手机号码区号
export const AreaList = params => {
	return Http.request({
		url: '/stock/countryAreaCode/list',
		method: 'get',
		params
	})
}

// 协议
export const Agreement = (type) => {
	return Http.request({
		url: '/stock/agreement/list',
		method: 'post',
		data:{
			type
		}
	})
}

// 邮箱验证码
export const SMSEmail = (data) => {
	return Http.request({
		url: '/stock/user/send_email_code_admin',
		method: 'post',
		data
	})
}

// 手机号
export const SMSPhone = (data) => {
	return Http.request({
		url: '/stock/user/send_sms_code_admin',
		method: 'post',
		data
	})
}

// 上传
export function Upload(filePath){
	return Http.upload(`/stock/common/upload`, {
		name:'file',
		filePath
	})
}

// H5 系统基础配置
export function GetSystemBasic(){
	return Http.request({
		url: '/stock/systemConfig/user/getSystemBasic',
		method: 'post',
		data: {}
	})
}

// 关于我们
export function AboutUs(){
	return Http.request({
		url: '/stock/platform/list',
		method: 'get'
	})
}
